module.exports = __webpack_public_path__ + "static/media/06.78037952.mp3";